import renderCollectionItems from '../actions/renderCollectionItems';

/**
 * General Collection Items block
 */
const CollectionItems =( $ )=>{

	if ( $( 'body' ).hasClass( 'collection-template-default' ) ) {
		renderCollectionItems();
	}

};

export default CollectionItems;
